import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Button.module.css';
/** Bouton d'action. Le libellé est toujours fourni par l'appelant (D15, pas de texte en dur). */
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', loading = false, disabled, className, children, ...rest }, ref) {
    return (_jsxs("button", { ref: ref, type: "button", className: classesBouton(variant, size, className), disabled: disabled || loading, "aria-busy": loading || undefined, ...rest, children: [loading ? _jsx("span", { className: styles.spinner, "aria-hidden": "true" }) : null, children] }));
});
/**
 * Classes d'un bouton à poser sur un lien : `<Link>` du routeur ou `<a>`.
 * Une navigation reste un lien (clic droit, nouvel onglet), mais quand elle
 * tient lieu d'action (« Ouvrir », « Télécharger ») elle s'affiche en bouton.
 */
export function classesBouton(variant = 'secondary', size = 'md', className) {
    return [styles.button, styles[variant], size !== 'md' ? styles[size] : '', className]
        .filter(Boolean)
        .join(' ');
}
/** Lien `<a>` au gabarit d'un bouton : téléchargement direct (`download`) ou URL externe. */
export const ButtonLink = forwardRef(function ButtonLink({ variant = 'secondary', size = 'md', className, children, ...rest }, ref) {
    return (_jsx("a", { ref: ref, className: classesBouton(variant, size, className), ...rest, children: children }));
});
//# sourceMappingURL=Button.js.map